
import React, { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import {ProductCategory} from './ProductCategory';
import './categorywise.css';
export default function CategoryWise() {
  const { category } = useParams();
  const decodedCategory = category.toLowerCase();
  const [search, setSearch] = useState('');
  const [visible, setVisible] = useState(4);
  const [cart, setCart] = useState([]);

  useEffect(() => {
    const saved = JSON.parse(localStorage.getItem('cart') || '[]');
    setCart(saved);
  }, []);

  const addToCart = (p) => {
    const now = [...cart, p];
    setCart(now);
    localStorage.setItem('cart', JSON.stringify(now));
  };

  const filtered = ProductCategory.filter(p => {
    return (category==='all' || p.category===decodedCategory) &&
      (p.name.toLowerCase().includes(search.toLowerCase()) ||
       p.description.toLowerCase().includes(search.toLowerCase()));
  });

  return (
    <div className="products-page">
      <h2>{category==='all'? 'All Products' : decodedCategory.replace(/-/g,' ')}</h2>

      <input
        type="search" placeholder="Search products..."
        value={search} onChange={e=>setSearch(e.target.value)}
        className="search-input"
      />

      <div className="product-grid">
        {filtered.slice(0, visible).map(product=>(
          <div key={product.id} className="product-card">
            <img src={product.image} alt={product.name}/>
            <h4>{product.name}</h4>
            <p>₹{product.price}</p>
            <p>{product.description}</p>
            <button onClick={()=>addToCart(product)}>
              Add to Cart ({cart.filter(c=>c.id===product.id).length})
            </button>
          </div>
        ))}
      </div>

      {visible < filtered.length && (
        <button className="load-more" onClick={()=>setVisible(v=>v+4)}>
          Load More
        </button>
      )}
    </div>
  );
}
